var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6665 8.9043H0.842499C0.428499 8.9043 0.0924988 8.5683 0.0924988 8.1543C0.0924988 7.7403 0.428499 7.4043 0.842499 7.4043H18.6665C19.0805 7.4043 19.4165 7.7403 19.4165 8.1543C19.4165 8.5683 19.0805 8.9043 18.6665 8.9043Z",
    fill: "#718EBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2012 12.8105C13.7872 12.8105 13.4472 12.4745 13.4472 12.0605C13.4472 11.6465 13.7782 11.3105 14.1922 11.3105H14.2012C14.6152 11.3105 14.9512 11.6465 14.9512 12.0605C14.9512 12.4745 14.6152 12.8105 14.2012 12.8105Z",
    fill: "#718EBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7637 12.8105C9.3497 12.8105 9.0097 12.4745 9.0097 12.0605C9.0097 11.6465 9.3407 11.3105 9.7547 11.3105H9.7637C10.1777 11.3105 10.5137 11.6465 10.5137 12.0605C10.5137 12.4745 10.1777 12.8105 9.7637 12.8105Z",
    fill: "#718EBF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31689 12.8105C4.90289 12.8105 4.56189 12.4745 4.56189 12.0605C4.56189 11.6465 4.89389 11.3105 5.30789 11.3105H5.31689C5.73089 11.3105 6.06689 11.6465 6.06689 12.0605C6.06689 12.4745 5.73089 12.8105 5.31689 12.8105Z",
    fill: "#718EBF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2012 16.6973C13.7872 16.6973 13.4472 16.3613 13.4472 15.9473C13.4472 15.5333 13.7782 15.1973 14.1922 15.1973H14.2012C14.6152 15.1973 14.9512 15.5333 14.9512 15.9473C14.9512 16.3613 14.6152 16.6973 14.2012 16.6973Z",
    fill: "#718EBF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7637 16.6973C9.3497 16.6973 9.0097 16.3613 9.0097 15.9473C9.0097 15.5333 9.3407 15.1973 9.7547 15.1973H9.7637C10.1777 15.1973 10.5137 15.5333 10.5137 15.9473C10.5137 16.3613 10.1777 16.6973 9.7637 16.6973Z",
    fill: "#718EBF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31689 16.6973C4.90289 16.6973 4.56189 16.3613 4.56189 15.9473C4.56189 15.5333 4.89389 15.1973 5.30789 15.1973H5.31689C5.73089 15.1973 6.06689 15.5333 6.06689 15.9473C6.06689 16.3613 5.73089 16.6973 5.31689 16.6973Z",
    fill: "#718EBF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7935 4.791C13.3795 4.791 13.0435 4.455 13.0435 4.041V0.75C13.0435 0.336 13.3795 0 13.7935 0C14.2075 0 14.5435 0.336 14.5435 0.75V4.041C14.5435 4.455 14.2075 4.791 13.7935 4.791Z",
    fill: "#718EBF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7153 4.791C5.3013 4.791 4.9653 4.455 4.9653 4.041V0.75C4.9653 0.336 5.3013 0 5.7153 0C6.1293 0 6.4653 0.336 6.4653 0.75V4.041C6.4653 4.455 6.1293 4.791 5.7153 4.791Z",
    fill: "#718EBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_517_796",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 20,
    height: 21
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.57812H19.5V21.499H0V1.57812Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_517_796)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.521 3.07812C2.928 3.07812 1.5 4.46113 1.5 6.97213V16.0211C1.5 18.5871 2.928 19.9991 5.521 19.9991H13.979C16.572 19.9991 18 18.6131 18 16.0971V6.97213C18.004 5.73712 17.672 4.77713 17.013 4.11713C16.335 3.43712 15.29 3.07812 13.988 3.07812H5.521ZM13.979 21.4991H5.521C2.116 21.4991 0 19.4001 0 16.0211V6.97213C0 3.64412 2.116 1.57812 5.521 1.57812H13.988C15.697 1.57812 17.11 2.09012 18.075 3.05712C19.012 3.99813 19.505 5.35112 19.5 6.97412V16.0971C19.5 19.4291 17.384 21.4991 13.979 21.4991Z",
    fill: "#718EBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.a2cdcb4bb9f457854e5fd57f05f10f74.svg";
export { ForwardRef as ReactComponent };